import React, { Component } from "react";
import "./styles.css";
import G from "../../../js/globals";
import Icon            from "../../prefabs/icon/view";
import PriceTicker     from "../price-ticker/view";
import SummarySection  from "../summary-section/view";
import StarItem        from "./star-item";

class FloatingSidebar extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.handleClickSummary = this.handleClickSummary.bind(this);
    this.handleClickHome    = this.handleClickHome.bind(this);
    this.handleClickEnd     = this.handleClickEnd.bind(this);

    this.onClickLeft        = this.onClickLeft.bind(this);
    this.onClickRight       = this.onClickRight.bind(this);



    this.navs = this.props.items.slice();
    this.navs.shift();  // Remove "intro"

    this.firstSlide = 0;
    this.lastSlide  = this.props.items.length - 1;

    this.cachedIntroError = null;
  }



  // ===============================================================================================
  handleClickSummary(type) {
    let items = this.props.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].id === type) {
        this.props.handleChange(i);
        break;
      }
    }
  }



  // ===============================================================================================
  handleClickHome() {
    // console.log(`SIDEBAR:\n Clicked ${0} (${this.props.items[0].id})`);
    this.props.handleChange('intro');
  }



  // ===============================================================================================
  handleClickEnd() {
    // console.log(`SIDEBAR:\n Clicked ${this.lastSlide} (${this.props.items[this.lastSlide].id})`);
    this.props.handleChange(this.lastSlide);
  }



  // ===============================================================================================
  onClickLeft(e) {
    e.preventDefault();
    if (this.props.activeSlide !== this.firstSlide) {
      // console.log(`SIDEBAR:\n Clicked previous slide`);
      this.props.handleChange(this.props.activeSlide - 1);
    }
  }



  // ===============================================================================================
  onClickRight(e) {
    e.preventDefault();
    if (this.props.activeSlide !== this.lastSlide) {
      // console.log(`SIDEBAR:\n Clicked next slide`);
      this.props.handleChange(this.props.activeSlide + 1);
    }
  }



  // ===============================================================================================
  render() {

    let partyTitle = {
      "hosted": "Birthday Party",
      "no-host": "Event"
    };

    // ---------------------------------------------------------------------------------------------
    // Get current slide name (controls background colour in CSS)
    let slideName = null;
    if (this.props.items && this.props.items[this.props.activeSlide]) {
      slideName = this.props.items[this.props.activeSlide].id;
    }



    // ---------------------------------------------------------------------------------------------
    let viewNames = (
      <StarItem label="Someone’s" />
    );

    if (this.props.sIntro && this.props.sIntro.stars) {
      let starList = (this.props.sIntro.stars).filter((item) => {
        if (this.props.eventType === "hosted") {
          if (item.name !== "" && item.age !== "") {
            return true;
          }
        } else if (this.props.eventType === "no-host") {
          if (item.name !== "") {
            return true;
          }
        }
        return false;
      });

      if (starList.length > 0) {
        
        if (this.props.eventType === "hosted") {

          viewNames = starList.map((item, i) => (
            <StarItem key={item.id} label={
              item.name + (item.name.endsWith('s') || item.name.endsWith('S') ? "’ " : "’s ") +
              item.age + G.helpers.getOrdinalSuffix(item.age) +
              ((i !== starList.length - 1) ? "," : "")
            } />
          ));

        } else if (this.props.eventType === "no-host") {

          viewNames = starList.map((item, i) => (
            <StarItem key={item.id} label={
              item.name + (item.name.endsWith('s') || item.name.endsWith('S') ? "’ " : "’s ") +
                  // Start of Selection
                  ((i !== starList.length - 1) ? ",\u00A0" : "\u00A0")
            } />
          ));

        }
      }
    }



    // ---------------------------------------------------------------------------------------------
    // Price display
    let viewPrices = [0, 0];

    if (this.props.price) {
      let iPrice = this.props.price;
      let sPrice = "" + iPrice;

      let priceOne = 0;
      let priceTwo = (iPrice < 10) ? "0" + sPrice : sPrice;

      if (iPrice > 99) {
        priceOne = sPrice.substring(0, sPrice.length-2);
        priceTwo = sPrice.substring(sPrice.length-2);
      }

      viewPrices[0] = parseInt(priceOne, 10) * 100;  // "Major", needs x100
      viewPrices[1] = parseInt(priceTwo, 10) * 10;   // "Minor", needs x10
    }



    // ---------------------------------------------------------------------------------------------
    // Check if an intro error exists
    let viewIntroError = null;

    if (this.props.sIntro.error && this.props.sIntro.error.label) {
      viewIntroError = this.props.sIntro.error.label;
    }

    let showIntroError = (viewIntroError !== null) ? true : false;

    if (this.cachedIntroError !== viewIntroError && viewIntroError !== null) {
      this.cachedIntroError = viewIntroError;
    }



    // ---------------------------------------------------------------------------------------------
    return (
      <nav className={"floating-sidebar" +
        ((!this.props.hidden) ? " floating-sidebar--shown" : "") +
        ((slideName) ? " floating-sidebar--" + slideName : "")}>
        <div className="floating-sidebar__wrapper">



          <div className="floating-sidebar__starlist">
            <div className="sidebar-item-container">

              <button
                className={"floating-sidebar__starlist__btn"}
                tabIndex="-1"
                onClick={this.handleClickHome}>
                {viewNames}
                <div>{partyTitle[this.props.eventType]}<Icon className="starlist-btn-icon" type="pen" /></div>
              </button>

              <div className={"sidebar-error sidebar-error--intro" +
                ((showIntroError) ? " sidebar-error--shown" : "")}>

                <div className="sidebar-error__message">
                  {this.cachedIntroError}
                </div>

              </div>

            </div>
          </div>



          <div className="floating-sidebar__pagelist">
            <SummarySection
              type={          "sidebar"                }
              items={         this.props.items         }
              activeSlide={   this.props.activeSlide   }
              visitedSlides={ this.props.visitedSlides }
              sIntro={        this.props.sIntro        }
              sPackage={      this.props.sPackage      }
              sLocation={     this.props.sLocation     }
              sDatetime={     this.props.sDatetime     }
              sCake={         this.props.sCake         }
              sSummary={      this.props.sSummary      }
              handleClick={   this.handleClickSummary  }
            />
          </div>



          <div className="floating-sidebar__price">
            <button
              className={"floating-sidebar__summary__btn"}
              tabIndex="-1"
              onClick={this.handleClickEnd}>
              <div className="floating-sidebar__total">
                Total (Incl. GST)
              </div>
              <div className="floating-sidebar__amount">
                <span className="amount-sign">$</span>
                <span className="amount-major">
                  <PriceTicker target={viewPrices[0]} type={"major"} />
                </span>
                <span className="amount-split">.</span>
                <span className="amount-minor">
                  <PriceTicker target={viewPrices[1]} type={"minor"} />
                </span>
                <span className="amount-disc Mcd_BPB__disclaimer-text">*</span>
              </div>
            </button>
          </div>



        </div>
      </nav>
    );
  }

}



export default FloatingSidebar
